import axios from 'axios';
import { createAsyncThunk, isFulfilled, isPending } from '@reduxjs/toolkit';
import { IQueryParams, createEntitySlice, EntityState, serializeAxiosError } from 'app/shared/reducers/reducer.utils';
import { IRepairModeAuditHistory, defaultValue } from 'app/shared/model/repair-mode-audit-history.model';

const initialState: EntityState<IRepairModeAuditHistory> = {
  loading: false,
  errorMessage: null,
  entities: [],
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

const apiUrl = 'api/repair-mode-audit-histories';

export const getEntities = createAsyncThunk(
  'repairModeAuditHistory/fetch_entity_list',
  async ({ page, size, sort, filterUrl }: IQueryParams) => {
    const requestUrl = `${apiUrl}?${filterUrl ?? ''}${
      sort ? `page=${page}&size=${size}&sort=${sort}&` : ''
    }cacheBuster=${new Date().getTime()}`;
    return axios.get<IRepairModeAuditHistory[]>(requestUrl);
  },
  { serializeError: serializeAxiosError },
);

export const RepairModeAuditHistorySlice = createEntitySlice({
  name: 'repairModeAuditHistory',
  initialState,
  extraReducers(builder) {
    builder
      .addMatcher(isFulfilled(getEntities), (state, action) => {
        const { data, headers } = action.payload;
        return {
          ...state,
          loading: false,
          entities: data,
          totalItems: parseInt(headers['x-total-count'], 10),
        };
      })
      .addMatcher(isPending(getEntities), state => {
        state.errorMessage = null;
        state.loading = true;
      });
  },
});

export const { reset } = RepairModeAuditHistorySlice.actions;

export default RepairModeAuditHistorySlice.reducer;
